module.exports = __webpack_public_path__ + "static/img/weixin_findpwd.cf20378.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gyn/weixin_findpwd.jpg
// module id = eV4W
// module chunks = 1